import apiClient from '../../../Services/ApiClient';
import { WizardAction } from '../Interfaces/Wizard.interface';
import { WizardActionType } from '../Enums/WizardActionType.enum';
import { WizardActionDestination } from '../Enums/WizardActionDestination.enum';

export const checkWizardExist = async (
	key: string,
	initialData?: object,
): Promise<boolean> => {
	try {
		const response = await apiClient.post(`/wizard/${key}/tree`, initialData);
		return !!response.data;
	} catch (e) {
		console.log('WIZARD DOESNT EXIST!');
	}
	return false;
};

export const resolveWizardAction = (action?: WizardAction) => {
	if (!action) {
		return;
	}

	if (action.type !== WizardActionType.REDIRECT) {
		return;
	}

	if (action.destination === WizardActionDestination.BROWSER && action.url) {
		window.location.href = action.url;
		return;
	}

	if (action.destination === WizardActionDestination.CREATE_CASE) {
		window.location.href = '/moje-pozadavky';
		return;
	}

	if (action.destination === WizardActionDestination.WIZARD_ONLINE) {
		const params = new URLSearchParams();

		if (action.initialData !== undefined) {
			params.set('initialData', JSON.stringify(action.initialData));
		}

		const query = params.toString();

		window.location.href = `/wizard/${action.wizardId}${
			query ? `?${query}` : ''
		}`;
		return;
	}
};
